import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import { Globe } from "lucide-react";
import api from "@/lib/api";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();

  const changeLanguage = async (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("lv_language", code);
    try {
      await api.put("/agency/user/language", { preferred_language: code });
    } catch {}
  };

  if (compact) {
    return (
      <div className="flex items-center gap-0.5" data-testid="language-switcher">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`px-2 py-1 text-xs font-bold tracking-wider rounded-sm transition-colors ${
              i18n.language === lang.code
                ? "bg-[#002FA7] text-white"
                : "text-[#868E96] hover:bg-[#F1F3F5]"
            }`}
            data-testid={`lang-${lang.code}`}
          >
            {lang.flag}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <Globe size={14} className="text-[#868E96]" />
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`px-2.5 py-1 text-xs font-bold tracking-wider rounded-sm transition-colors ${
            i18n.language === lang.code
              ? "bg-[#002FA7] text-white"
              : "text-[#868E96] hover:bg-[#F1F3F5] border border-border"
          }`}
          data-testid={`lang-${lang.code}`}
        >
          {lang.flag}
        </button>
      ))}
    </div>
  );
}
